<template>
  <div class="ksm-bibliographie__page--wrapper">
    <div class="ksm-bibliographie__page">
      <div class="ksm-bibliographie__content">
        <div class="ksm-bibliographie__categorie" v-for="(bibl,key) of bibliographie" :key="key">
          <div class="__title">{{titles[key]}}</div>
          <div class="__body">
            <template v-for="(p,i) of bibl">
              <div
                class="ksm-bibliographie__item"
                :key="'p'+i"
                :data-keyitem="getKeyItem(p,this)"
                :class="keyitem==p.keyitem.toLowerCase()?'active':''"
              >
                <div class="__subtitle">[{{p.shorttitle}}]</div>
                <div class="__content" v-html="p.bib"></div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titles: {
        P: "PRIMÄRLITERATUR",
        A: "AUSSTELLUNGSKATALOGE",
        S: "SEKUNDÄRLITERATUR"
      },
      item: null
    };
  },
  watch: {
    item(k) {
      this.scrollToItem(k);
    }
  },
  methods: {
    scrollToItem(k) {
      if (!k) {
        return;
      }
      let vue = this;
      setTimeout(function() {
        let pattern = "[data-keyitem='" + k + "']";
        let item = vue.$el.querySelector(pattern);
        if (item) {
          item.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }, 100);
    },
    getKeyItem(it) {
      let keyitem = it.keyitem.toLowerCase();
      if (keyitem == this.keyitem) {
        this.item = keyitem;
      }
      return keyitem;
    }
  },
  mounted: function() {
    this.scrollToItem(this.item);
  },
  computed: {
    bibliographie() {
      return this.$store.getters.bibliographie;
    },
    keyitem() {
      let keyitem = this.$route.params.keyitem;
      if (keyitem) {
        return keyitem.toLowerCase();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ksm-bibliographie__page--wrapper {
  color: #000;
  background-color: #eee;
  @extend .ksm-flex;
}

.ksm-bibliographie__page {
  @extend .ksm-flex-1;
  position: relative;
}

.ksm-bibliographie__content {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px;
}

.ksm-bibliographie__categorie {
  padding-bottom: 10px;
  .__title {
    font-size: 16pt;
    padding: 5px 0px;
  }
}

.ksm-bibliographie__item {
  margin: 10px;
  &.active {
    background-color: rgba(133, 28, 28, 0.4);
  }
  .__content {
    padding-left: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// Bibliographie.vue?d2654eb4